export const undeletableReasonViewTexts = {
  koumuten: '設計会社が登録されているため削除できません。',
  company: 'プロジェクトまたは推論モデルが登録されているため削除できません。',
  model: 'この推論モデルはプロジェクトで利用されているため削除できません。',
  project: '承認済みのプロジェクトは削除出来ません。',
  user:
    'このユーザーに紐づく設計会社またはプロジェクトがあるため削除出来ません。'
} as const;
